import * as angular from "angular";
import template from "./entity-tokens-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityTokensTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityTokensTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewTokens = globs.entityTypes.byType(this.typeConfig.Code).tokens.byCode("*").read;
		this.tab = {
			name: "Tokens",
			code: "TOKENS",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewTokens)
				&& isSupportedOrNullish(this.typeConfig.Tokens)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-tokens-tab", [])
	.component("entityTokensTab", {
		controller: EntityTokensTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
